import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { useCallback } from "react";
import { CheckboxTree, CheckboxTreeChange } from "react-migration/components/CheckboxTree";
import { RenderNodeBadge, TreeStructure } from "react-migration/components/CheckboxTree/types";
import { CheckboxSchema } from "../Multilayer/layer_types/ConstraintsLayerType";
import { useControlTracking } from "../Multilayer/ControlTrackingContext";
import clsx from "clsx";
interface GenericCategoryFilterProps {
  id: string;
  categorySchema: CheckboxSchema[];
  disabled: boolean;
  visibleCategoryIds: string[];
  setVisibleCategories(visibleCategories: string[]): void;
  renderNodeBadge?: RenderNodeBadge;
  title?: JSX.Element;
  categoryTree: TreeStructure | null;
  getCollapsed?: (id: string) => boolean;
  setCollapsed?: (id: string, value: boolean) => void;
}

export function GenericCategoryFilter({
  categorySchema,
  disabled,
  visibleCategoryIds,
  setVisibleCategories,
  renderNodeBadge,
  title,
  categoryTree,
  getCollapsed,
  setCollapsed,
}: Readonly<GenericCategoryFilterProps>) {
  const { trackControlChange } = useControlTracking();

  const handleChange = useCallback<CheckboxTreeChange>(
    ({ id, checked, visibleNodeIds }) => {
      trackControlChange({ filterName: id, filterState: checked });

      setVisibleCategories(visibleNodeIds);
    },
    [setVisibleCategories, trackControlChange]
  );

  if (!categoryTree) {
    return (
      <div className="relative overflow-hidden" style={{ minHeight: 60 }}>
        <SkeletonLoading rows={1} bgClassName="bg-neutral-50" showPadding={false} />
      </div>
    );
  }

  return (
    <div className="">
      <div
        className={clsx("flex flex-col gap-2 pb-4", {
          "opacity-50": disabled,
        })}
      >
        <CheckboxTree
          title={title}
          treeStructure={categoryTree}
          treeSchema={categorySchema}
          onChange={handleChange}
          visibleNodeIds={visibleCategoryIds}
          renderNodeBadge={renderNodeBadge}
          getCollapsed={getCollapsed}
          setCollapsed={setCollapsed}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
